import {
    ADD_SCENARIO_VARIATION_ITEMS,
    ADD_GROUP,
    ADD_VARIATION_UUID_TO_LIST,
    ADD_VARIATION_NAME_TO_LIST,
    SET_CREATE_GROUP_REQUEST,
    SET_CREATE_GROUP_SUCCESS,
    SET_CREATE_GROUP_ERROR,
    ADD_BULK_VARIATION_TO_LIST,
    ADD_BULK_VARIATION_COUNT,
    SET_CURRENT_PAGE_NUMBER,
} from "../../../constants/closeLoop/scenarioCollection/addToCartScenarioCollectionConstants";

const initialCartState = {
    count: 0,
    items: [],
    group: "",
};

export const addToCartScenarioCollectionReducers = (state = initialCartState, action) => {
    switch (action.type) {
        case ADD_SCENARIO_VARIATION_ITEMS:
            return {
                count: action.count,
                items: action.items,
            };
        case ADD_GROUP:
            return {
                ...state,
                group: action.group,
            };
        default:
            return state;
    }
};

export const selectedScenarioUuidList = (state = { variationUuidList: [] }, action) => {
    switch (action.type) {
        case ADD_VARIATION_UUID_TO_LIST:
            return {
                variationUuidList: action.variationUuidList,
            };
        default:
            return state;
    }
};

export const selectedScenarioNameList = (state = { variationNameList: [] }, action) => {
    switch (action.type) {
        case ADD_VARIATION_NAME_TO_LIST:
            return {
                variationNameList: action.variationNameList,
            };
        default:
            return state;
    }
};

const initialGroupCreationStatus = {
    loading: false,
    groupCreationStatus: {},
};

export const addVariationToGroupReducers = (state = initialGroupCreationStatus, action) => {
    switch (action.type) {
        case SET_CREATE_GROUP_REQUEST:
            return {
                loading: true,
                groupCreationStatus: {},
                error: "",
            };
        case SET_CREATE_GROUP_SUCCESS:
            return {
                loading: false,
                groupCreationStatus: action.variationGroupStatus,
                error: "",
            };
        case SET_CREATE_GROUP_ERROR:
            return {
                loading: false,
                groupCreationStatus: {},
                error: action.payload,
            };
        default:
            return state;
    }
};

const initialBulkScenarioState = {
    selectedScenarioObjectList: {},
};

export const addBulkScenariosToListReducers = (state = initialBulkScenarioState, action) => {
    switch (action.type) {
        case ADD_BULK_VARIATION_TO_LIST:
            return {
                selectedScenarioObjectList: action.selectedScenarioObjectList,
            };
        default:
            return state;
    }
};

const initialBulkVariationCount = {
    bulkVariationCount: 0,
};

export const bulkVariationCartCountReducer = (state = initialBulkVariationCount, action) => {
    switch (action.type) {
        case ADD_BULK_VARIATION_COUNT:
            return {
                totalBulkVariationSelected: action.totalBulkVariationSelected,
            };
        default:
            return state;
    }
};

const initialcurrentPageNumber = {
    currentPageNumber: 0,
};

export const currentPageNumberReducer = (state = initialcurrentPageNumber, action) => {
    switch (action.type) {
        case SET_CURRENT_PAGE_NUMBER:
            return {
                currentPageNumber: action.currentPageNumber,
            };
        default:
            return state;
    }
};
